<template>
  <b-row>
    <b-col cols="10">
      <b-row>
        <b-col cols="8">
          <b-form-group>
              <label for="extension"><i class="fa fa-user"></i> Endpoint (Deprecated, Use Extensions)</label>
              <b-form-input disabled v-model="endpoint" />
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <label :for="`duration-${id}`">Duration</label>
          <b-form-input disabled v-model="duration" />
        </b-col>
      </b-row>
    </b-col>
    <b-col cols="2" class="text-right">
      <b-btn-group>
        <!-- <b-btn size="sm" v-if="dirty" @click="save()" variant="success"><i class="fa fa-check"></i></b-btn> -->
        <b-btn size="sm" variant="danger" @click="del()"><i class="fa fa-trash"></i></b-btn>
      </b-btn-group>
    </b-col>
  </b-row>
</template>
<script>

export default {
  name: 'Endpoint',
  props: [ 'index', 'value', 'extensions' ],
  computed: {
  },
  data () {
    return {
      id: null,
      endpoint: null,
      duration: null
    }
  },
  created () {
    this.id = this.value.id
    this.endpoint = this.value.actionId
    this.duration = this.value.duration
  },
  methods: {
    async del () {
      const id = this.value.id || null
      if (id) {
        await this.$axios.delete(`/v1/numbers/routes/${id}`)
      }
      this.$emit('update', 'delete', this.index)
    }
  },
  watch: {
    value: {
      handler () {
        this.id = this.value.id
        this.endpoint = this.value.actionId
        this.duration = this.value.duration
      }
    },
  }
}
</script>
